const LOAD_REGISTRATIONS = {
  BEGIN: "LOAD_REGISTRATIONS_BEGIN",
  SUCCESS: "LOAD_REGISTRATIONS_SUCCESS",
  FAILURE: "LOAD_REGISTRATIONS_FAILURE"
};

const LOAD_REGISTRATION = {
  BEGIN: "LOAD_REGISTRATION_BEGIN",
  SUCCESS: "LOAD_REGISTRATION_SUCCESS",
  FAILURE: "LOAD_REGISTRATION_FAILURE"
};

const UPDATE_REGISTRATION = {
  BEGIN: "UPDATE_REGISTRATION_BEGIN",
  SUCCESS: "UPDATE_REGISTRATION_SUCCESS",
  FAILURE: "UPDATE_REGISTRATION_FAILURE"
};

const initialState = {};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_REGISTRATIONS.SUCCESS:
      return action.payload;
    case LOAD_REGISTRATION.SUCCESS: {
      const { id } = action.payload;
      return { ...state, [id]: action.payload };
    }
    case UPDATE_REGISTRATION.SUCCESS: {
      const registrationIds = action.payload;
      registrationIds.forEach(id => delete state[id]);

      return { ...state };
    }
    default:
      return state;
  }
}

export const loadRegistrations = () => {
  return {
    types: [
      LOAD_REGISTRATIONS.BEGIN,
      LOAD_REGISTRATIONS.SUCCESS,
      LOAD_REGISTRATIONS.FAILURE
    ],
    api: api => api.loadRegistrations()
  };
};

export const updateRegistration = body => {
  return {
    types: [
      UPDATE_REGISTRATION.BEGIN,
      UPDATE_REGISTRATION.SUCCESS,
      UPDATE_REGISTRATION.FAILURE
    ],
    api: api => api.updateRegistration(body)
  };
};

export const loadRegistration = id => {
  return {
    types: [
      LOAD_REGISTRATION.BEGIN,
      LOAD_REGISTRATION.SUCCESS,
      LOAD_REGISTRATION.FAILURE
    ],
    api: api => api.loadRegistration(id)
  };
};
